import React from "react";
import style from "./quotation.module.scss";
const Quotation = () => {
  return <div>Quotation</div>;
};

export default Quotation;
